import React from 'react'
import ReactDOM from 'react-dom/client'
import ValuationApp from './ValuationApp'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ValuationApp />
  </React.StrictMode>
)
